export default function DashboardCard({ title, value, onClick, accent }) {
  const clickable = typeof onClick === "function";

  const accentMap = {
    blue: "hover:border-accent-blue/60 hover:shadow-[0_0_16px_rgba(31,157,255,0.18)]",
    teal: "hover:border-accent-teal/60 hover:shadow-[0_0_16px_rgba(22,242,212,0.18)]",
    yellow: "hover:border-yellow-400/60 hover:shadow-[0_0_16px_rgba(250,204,21,0.18)]",
    red: "hover:border-red-500/60 hover:shadow-[0_0_16px_rgba(239,68,68,0.18)]"
  };

  return (
    <div
      onClick={onClick}
      className={`
        relative
        p-4 rounded-lg
        bg-slate-900/80
        border border-slate-800
        transition-all duration-200
        ${clickable ? "cursor-pointer hover:bg-slate-900" : ""}
        ${accent ? accentMap[accent] : ""}
      `}
    >
      <div className="text-[11px] text-gray-400 font-mono uppercase tracking-widest">
        {title}
      </div>

      <div className="mt-2 text-2xl font-semibold text-gray-100">
        {value ?? "—"}
      </div>
    </div>
  );
}